import { CreateMessageSetVersion, CreateMessageSetVersionVariables } from './__generated__/CreateMessageSetVersion'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateMessageSetVersion($input: CreateMessageSetVersionInputV2!) {
    createMessageSetVersionV2(input: $input) {
      ... on MessageSetVersionErrorV2 {
        type
        error
      }
      ... on MessageSetVersionV2 {
        id
        title
        messageSetId
        messages {
          id
          text
          characters
          createdAt
          tags
          cardSize
        }
      }
    }
  }
`

export const useCreateMessageSetVersion = () =>
  useMutation<CreateMessageSetVersion, CreateMessageSetVersionVariables>(MUTATION)
